import { render, staticRenderFns } from "./BCardCode.vue?vue&type=template&id=f0766e34&scoped=true"
import script from "./BCardCode.vue?vue&type=script&lang=js"
export * from "./BCardCode.vue?vue&type=script&lang=js"
import style0 from "./BCardCode.vue?vue&type=style&index=0&id=f0766e34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0766e34",
  null
  
)

export default component.exports